const TableViewSvg = (): JSX.Element => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
            d="M3 3H21M3 9H21M3 15H21M3 21H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            />
        </svg>
    );
};

export default TableViewSvg;
